import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { SubcategoryWithCategory } from "app/_models/subcategories";
import { CrudSubcategoryService } from "app/_services/MasterCrudOps/crud-subcategory.service";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";
import { LiveAnnouncer } from "@angular/cdk/a11y";
import { AddSubCategoryComponent } from "./add-sub-category/add-sub-category.component";
import { EditSubCategoryComponent } from "./edit-sub-category/edit-sub-category.component";
import * as XLSX from "xlsx";
import { DatePipe } from "@angular/common";
import { UserModel } from "app/_models/user-model";
declare const swal: any;

@Component({
  selector: "app-sub-category",
  templateUrl: "./sub-category.component.html"
})
export class SubCategoryComponent implements OnInit, AfterViewInit {
  currentUser: UserModel;
  isAdminGroupUser: boolean = false;
  subcategoryWithCategories: SubcategoryWithCategory[];
  totalresultDetails: SubcategoryWithCategory[];
  displayedColumns: string[] = [
    "icon",
    "productName",
    "categoryName",
    "subCategoryName",
    "description",
    "edit",
    "delete",
  ];
  dataSource = new MatTableDataSource<SubcategoryWithCategory>([]);
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) set sort(value: MatSort) {
    if (this.dataSource != null) {
      this.dataSource.sort = value;
    }
  }
  isLoaderResult = true;
  resultLength = 0;
  totalRows = 0;
  pageSize = 25;
  currentPage = 0;
  pageSizeOptions: number[] = [25, 50, 75, 100];
  editSubCategory: SubcategoryWithCategory;
  pageEvent = { pageSize: 25, pageIndex: 0 };

  constructor(
    public datepipe: DatePipe,
    private readonly  _liveAnnouncer: LiveAnnouncer,
    private  readonly  matDialog: MatDialog,
    private readonly  crudSubcategoryService: CrudSubcategoryService,
   
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
  }

  ngOnInit() {
    this.isLoaderResult = true;
    this.dataSource = null;
    this.subcategoryWithCategories = null;
    this.pageSize = 25;
    this.getSubcategories(1, this.pageSize, false);
    this.isLoaderResult = false;
  }

  ngAfterViewInit() {
    if (this.dataSource != null) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  getSubcategories(
    pageNumber: number,
    currPageSize: number,
    hasDownloadAllData: boolean
  ) {
    let model = {
      currentPage: pageNumber,
      pageSize: currPageSize,
      downloadAllData: hasDownloadAllData,
      stateId: 0,
    };
    this.crudSubcategoryService
      .getPagedSubactegoriesWithCategories(model)
      .subscribe(
        (data) => {
          this.isLoaderResult = false;
          if (!data.didError) {
            this.subcategoryWithCategories = data.model;
            this.dataSource = new MatTableDataSource<SubcategoryWithCategory>(
              this.subcategoryWithCategories
            );
            this.totalRows = data.totalRecords;
            this.resultLength = this.subcategoryWithCategories.length;
          } else {
            this.subcategoryWithCategories = data.model;
            swal({
              title: "",
              text: data.message,
              type: "error",
              confirmButtonClass: "btn btn-info",
            });
          }
        },
        (error) => {
          this.isLoaderResult = false;
          swal({
            title: "",
            text: "Somthing went wrong. Please contact admin",
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }
      );
  }

  onEditSubCategory(e:any, element:any): void {
    this.editSubCategory = JSON.parse(JSON.stringify(element));
    const dialogRef = this.matDialog.open(EditSubCategoryComponent, {
      width: "850px",
      disableClose: true,
      data: {
        subcategory: this.editSubCategory,
        pageNumber: this.paginator.pageIndex + 1,
        pageSize: this.paginator.pageSize,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getSubcategories(result.pageNumber, result.pageSize, false);
        setTimeout(() => {}, 1500);
      }
    });
  }

  onDeleteSubCategory(e:any, element:any) {
    swal({
      title: "Are you sure to delete?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Delete IT!",
    }).then((result) => {
      if (result === true) {
        this.deleteSubCategory(e, element);
      }
    });
  }

  deleteSubCategory(e:any, element:any): void {
    this.isLoaderResult = true;
    this.crudSubcategoryService
      .deleteSubCategory(element.subCategoryId)
      .subscribe((data) => {
        if (data.didError) {
          swal({
            title: "",
            text: data.message + "\n" + data.additionalMessage,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          swal({
            title: "",
            text: data.message,
            type: "success",
            confirmButtonClass: "btn btn-info",
          });
          this.getSubcategories(
            this.paginator.pageIndex + 1,
            this.paginator.pageSize,
            false
          );
        }
      });
    this.isLoaderResult = false;
  }

  /** Announce the change in sort state for assistive technology. */
  announceSubCategorySort(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.

    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce("Sorting cleared");
    }
  }

  onAddSubCategoryClick() {
    const dialogRef = this.matDialog.open(AddSubCategoryComponent, {
      width: "850px",
      disableClose: false,
      data: {
        pageNumber: this.paginator.pageIndex + 1,
        pageSize: this.paginator.pageSize,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status) {
        this.getSubcategories(result.pageNumber, result.pageSize, false);
        setTimeout(() => {}, 1500);
      }
    });
  }

  onDownloadSubCategoriesClick() {
    swal({
      title: "Are you sure to do this?",
      text: "This process does not display data. It will download all records in a spreadsheet.",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Download the records.",
    }).then((result) => {
      if (result === true) {
        this.isLoaderResult = true;
        let model = {
          currentPage: 0,
          pageSize: 0,
          downloadAllData: true,
          stateId: 0,
        };
        this.crudSubcategoryService
          .getPagedSubactegoriesWithCategories(model)
          .subscribe(
            (results) => {
              this.isLoaderResult = false;
              if (!results.didError) {
                this.totalresultDetails = results.model;
                const workSheet = XLSX.utils.json_to_sheet(
                  this.totalresultDetails.map((item) => {
                    return {
                      Product: item.productName,
                      Category: item.categoryName,
                      SubCategory: item.subCategoryName,
                      ItemCode: item.itemCode,
                      Description: item.description,
                    };
                  })
                );
                const workBook: XLSX.WorkBook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workBook, workSheet, "SheetName");
                let fileName =
                  "Subcategories_" +
                  this.datepipe.transform(new Date(), "dd_MM_yyyy_hh_mm") +
                  ".xlsx";
                XLSX.writeFile(workBook, fileName);
              } else {
                this.isLoaderResult = false;
                swal({
                  title: "",
                  text: results.message,
                  type: "error",
                  confirmButtonClass: "btn btn-info",
                });
              }
            },
            (error) => {
              this.isLoaderResult = false;
              swal({
                title: "",
                text: "Somthing went wrong. Please contact admin",
                type: "error",
                confirmButtonClass: "btn btn-info",
              });
            }
          );
      }
    });
  }

   applySubCategoryFilter(filterValue: string) {
       this.dataSource.filter = filterValue;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getSubcategories(
      this.paginator.pageIndex + 1,
      this.paginator.pageSize,
      false
    );
  }
}
